import script from "./survay.vue?vue&type=script&setup=true&lang=js"
export * from "./survay.vue?vue&type=script&setup=true&lang=js"

import "./survay.vue?vue&type=style&index=0&id=f65a2fbe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f65a2fbe"]])

export default __exports__